import React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Box, Grid, Typography } from "@mui/material";
import { WallClockIcon } from "../../../Assets/Table/WallClockIcon";
import { DatabaseIcon } from "../../../Assets/Table/DatabaseIcon";
import { HospitalIcon } from "../../../Assets/Table/HospitalIcon";
import { MedicalCareIcon } from "../../../Assets/Table/MedicalCareIcon";
import { SortDIcons } from "../../../Assets/Table/SortDIcons";

const Finance = ({ tableHead, rows }) => {
  return (
    <Box
      sx={{
        padding: "10px 20px",
      }}
    >
      <TableContainer
        component={Paper}
        sx={{
          backgroundColor: "#F9FBFC",
          maxHeight: "82vh",
        }}
      >
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead
            sx={{
              position: "sticky",
              top: 0,
              backgroundColor: "#F9FBFC",
            }}
          >
            <TableRow>
              <TableCell align="left">
                <Typography sx={tableHead}>
                  Time
                  <Box sx={{ cursor: "pointer" }}>
                    <SortDIcons />
                  </Box>
                </Typography>
              </TableCell>
              <TableCell align="left">
                {" "}
                <Typography sx={tableHead}>
                  Subject
                  <Box sx={{ cursor: "pointer", transform: "rotate(180deg)" }}>
                    <SortDIcons />
                  </Box>
                </Typography>
              </TableCell>
              <TableCell align="left">
                {" "}
                <Typography sx={tableHead}>
                  Item
                  <Box sx={{ cursor: "pointer" }}>
                    <SortDIcons />
                  </Box>
                </Typography>
              </TableCell>
              <TableCell align="left">
                <Typography sx={tableHead}>
                  Status
                  <Box sx={{ cursor: "pointer" }}>
                    <SortDIcons />
                  </Box>
                </Typography>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <TableRow
                align="left"
                key={row.name}
                sx={{
                  "&:last-child td, &:last-child th": { border: 0 },
                  cursor: "pointer",
                }}
              >
                <TableCell component="th" scope="row">
                  <Box
                    sx={{
                      display: "flex",
                      alignContent: "center",
                      gap: 1,
                    }}
                  >
                    <Box>
                      <Typography sx={tableHead}>{row.date}</Typography>
                      <Typography
                        sx={{
                          fontSize: "13px",
                          color: "#4C5A6A",
                        }}
                      >
                        {row.time}
                      </Typography>
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        bgcolor: "#788597",
                        alignItems: "center",
                        justifyContent: "center",
                        width: "50px",
                        height: "22px",
                        borderRadius: "20px",
                        color: "white",
                        fontSize: "11px",
                        marginTop: 1,
                      }}
                    >
                      New
                    </Box>
                  </Box>
                </TableCell>
                <TableCell
                  align="left"
                  sx={{
                    fontSize: "14px",
                    color: "#4C5A6A",
                  }}
                >
                  {row.subject}
                </TableCell>
                <TableCell align="left">
                  <Typography
                    sx={{
                      fontSize: "15px",
                      color: "#2E2E2E",
                      fontWeight: 600,
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      {row.section === "hospital" ? (
                        <HospitalIcon />
                      ) : (
                        <MedicalCareIcon />
                      )}
                    </Box>
                    {row.item}
                  </Typography>
                </TableCell>
                <TableCell align="left">
                  <Box
                    component={"span"}
                    sx={{
                      display: "flex",
                      gap: 1,
                      color: "#DC8E1F",
                      fontSize: "14px",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      {row.section === "hospital" ? (
                        <WallClockIcon />
                      ) : (
                        <DatabaseIcon />
                      )}
                    </Box>
                    {row.status}
                  </Box>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default Finance;
